function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16.667 3.813v12.374a.833.833 0 01-.415.721l-.826.48a.833.833 0 01-.831.002l-1.267-.723-1.24.72a.834.834 0 01-.833.001L10 16.667l-1.255.721a.833.833 0 01-.833-.001l-1.24-.72-1.267.723a.834.834 0 01-.831-.003l-.826-.479a.833.833 0 01-.415-.72V3.813c0-.298.158-.572.415-.721l.826-.48a.833.833 0 01.831-.002l1.267.723 1.24-.72a.833.833 0 01.833-.001L10 3.333l1.255-.721a.833.833 0 01.833.001l1.24.72 1.267-.723a.833.833 0 01.831.003l.826.479c.257.149.415.424.415.72z",
  stroke: "currentColor",
  strokeWidth: "1.278",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6.667v.673M10 13.333v-.673M11.624 8.393A1.626 1.626 0 0010 7.34c-.83-.079-1.57.52-1.667 1.346 0 .57.403 1.061.962 1.173l1.41.282c.56.112.962.603.962 1.173A1.532 1.532 0 0110 12.66a1.626 1.626 0 01-1.624-1.053",
  stroke: "currentColor",
  strokeWidth: "1.278",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));